module.exports = __webpack_public_path__ + "static/pinkstarveloursingle-b2d3822b9211cbd116876587286c3272.jpeg";